import { render, staticRenderFns } from "./PartnerUserBulkActions.vue?vue&type=template&id=a8da0d52"
import script from "./PartnerUserBulkActions.vue?vue&type=script&lang=ts"
export * from "./PartnerUserBulkActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports